import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../app/hooks';
import { BACKOFFICE_NAME } from '../../../helpers/helperFunctions';
import { P2 } from '../../../styles/FontStyles';
import { PaymentSuccess } from '../../../views/Settings/PaymentSuccess';
import { PaymentSuccess2 } from '../../../views/Settings/PaymentSuccess2';
import Spinner from '../Spinner';
import { VirtualOfficeSelectedOrder } from './VirtaulOfficeSelectedOrder';
import { VirtualOfficeSelectedPlan } from './VirtualOfficeSelectedPlan';
import { VirtualOfficeSubscription } from './VirtualOfficeSubscription';

interface SelectedPlanProps {
  selected: any;
  setSelected: any;
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  selectedHub?: number;
}

export const SelectedPlan = ({
  selected,
  setSelected,
  step,
  setStep,
  selectedHub
}: SelectedPlanProps) => {
  const { t } = useTranslation('settings');
  const { loading, loadingVerification } = useAppSelector(
    (state) => state.settings
  );
  const { addHubLoading, loading: creditCardLoading } = useAppSelector(
    (state) => state.marketplace
  );
  const [selectedToken, setSelectedToken] = useState<any>();

  const showSteps = (step: number) => {
    switch (step) {
      case 1:
        return (
          <>
            <P2>{t('virtual_office.message', { BACKOFFICE_NAME })}</P2>
            <VirtualOfficeSubscription
              selected={selected}
              setSelected={setSelected}
              setStep={setStep}
              buttonText={t('virtual_office.continue_with_selection')}
            />
          </>
        );

      case 2:
        return (
          <VirtualOfficeSelectedPlan
            step={3}
            setStep={setStep}
            selected={selected}
            selectedHub={selectedHub}
          />
        );

      case 3:
        return (
          <VirtualOfficeSelectedOrder
            step={4}
            setStep={setStep}
            selected={selected}
            selectedHub={selectedHub}
            selectedToken={selectedToken}
            setSelectedToken={setSelectedToken}
          />
        );

      case 4:
        return (
          <PaymentSuccess
            selected={selected}
            selectedHub={selectedHub}
            selectedToken={selectedToken}
          />
        );

      case 5:
        return <PaymentSuccess2 />;

      default:
        return null;
    }
  };
  return (
    <>
      {loading || addHubLoading || creditCardLoading || loadingVerification ? (
        <Spinner />
      ) : (
        <>{showSteps(step)}</>
      )}
    </>
  );
};
